import { BackButton, StyledText } from "../../../../components/common";
import { useTheme,  } from "../../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import blowClock from "../../../../components/images/blowClock.png";

const FastestFingerTips = () => {
  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();


  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "20px",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingInline: 15,
          backgroundColor: "white",
        }}
      >
        <StyledText style={{ marginTop: -1, fontSize: 24 }}>
          Fastest Finger
        </StyledText>
        <BackButton onClick={()=>history.goBack()} />
        <div style={{ alignSelf: "center" }}>
          <img width={100} src={blowClock}/>
        </div>
        <div>
          <StyledText style={{ fontSize: 22, fontFamily: "MTNMedium" }}>
            What is Fastest Finger?
          </StyledText>
        </div>
        <StyledText
          style={{
            fontFamily: "MTNMedium",
          }}
        >
          Yo Peeps! Be the fastest to recharge displayed PINs and win free
          airtime! T&Cs apply.
        </StyledText>

        <OutlinedContainer color={background}>
          <StyledText style={{ fontFamily: "MTNMedium", fontSize: 18 }}>
            Tips
          </StyledText>

          {tips.map((note, index) => {
            return (
              <TipsContainer key={index}>
                <CircleContainer>
                  <Dot color={background} />
                </CircleContainer>
                <StyledText
                  style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                >
                  {note}
                </StyledText>
              </TipsContainer>
            );
          })}
        </OutlinedContainer>
      </div>
    </div>
  );
};

export default FastestFingerTips;

const OutlinedContainer = styled.div`
  width: "90%";
  border-width: 2;
  border: 1.5px solid ${({ color }) => color};
  border-radius: 15px;
  padding-inline: 10px;
`;

const TipsContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
  margin-top: 5px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const tips = [
  "Click on the fastest finger card from the homepage to view details for the next airtime grabs and a guide on how to claim the displayed PIN.",
  "Wait until the countdown timer ends and the session begins.",
  "Once the session begins, you'll see a PIN displayed. Copy the PIN and paste it in your phone dialer.",
  "Redeem PIN by recharging with *134*PIN# in your phone dialer.",
  "After claiming or if you didn't win, return to the app to participate in the next opportunity.",
  "The last 3 numbers of the most recent recharge winner will be seen in recent activity.",
  "Keep an eye out for the next session from What’s happening section on the homepage.",
];
